module.exports = __webpack_public_path__ + "static/media/comercLogo.8d2a3846.png";